export const schedule_types_ids = {
  one_on_one_appointment: 0,
  one_on_one_class: 1,
  group_class: 2,
  workshop: 3,
  no_schedule: 4,
  content: 5,
  merchandise: 6,
  rolling_class: 7,
  telegram: 8,
  webinar: 9,
  whatsapp: 10,
  branded_community: 11,
};

export const SLOT_LISTING_TYPES = [
  schedule_types_ids.group_class,
  schedule_types_ids.one_on_one_class,
  schedule_types_ids.rolling_class,
  schedule_types_ids.webinar,
  schedule_types_ids.one_on_one_appointment,
  schedule_types_ids.workshop,
];

export const schedule_type_names = {
  [schedule_types_ids.one_on_one_appointment]: "1-1 consultations",
  [schedule_types_ids.one_on_one_class]: "One-on-One Class",
  [schedule_types_ids.group_class]: "Fixed Class",
  [schedule_types_ids.workshop]: "Workshop",
  [schedule_types_ids.no_schedule]: "Quick Payment Page",
  [schedule_types_ids.content]: "Courses",
  [schedule_types_ids.merchandise]: "Merchandise",
  [schedule_types_ids.rolling_class]: "Flexible Class",
  [schedule_types_ids.telegram]: "Telegram Community",
  [schedule_types_ids.webinar]: "Live Webinars",
  [schedule_types_ids.whatsapp]: "Whatsapp Community",
  [schedule_types_ids.branded_community]: "Branded Community",
};

export const address_type_enum = {
  meet: 0,
  joining_link: 1,
  personal_address: 2,
  customer_location: 3,
  zoom: 4,
  phone: 5,
  whatsapp: 6,
  exly_connect_by_zoom: 7,
  zoom_webinar: 8,
  none: 9,
  exly_zoom_webinar: 10,
};

export const address_type_data_map = {
  [address_type_enum.meet]: "Google meet",
  [address_type_enum.joining_link]: "Online Meeting Link",
  [address_type_enum.personal_address]: "At your personal address",
  [address_type_enum.customer_location]: "At customer's address",
  [address_type_enum.zoom]: "Zoom",
  [address_type_enum.phone]: "Phone",
  [address_type_enum.whatsapp]: "Whatsapp",
  [address_type_enum.exly_connect_by_zoom]: "Exly Zoom",
  [address_type_enum.none]: "None",
  [address_type_enum.exly_zoom_webinar]: "Exly Zoom Webinar",
};
